// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2eGC8","subheader":"ReorderModal_subheader__2dFLi","listWrap":"ReorderModal_listWrap__29yCP"};